export default __webpack_public_path__ + "static/media/mobile-white.d6799632.png";